<script setup lang="ts">
/**
 * Цена в плитке каталога. Расчёт («от» для групп и комбо) — общий хелпер
 * getCardPrice, чтобы разные шаблоны не показывали разные суммы за один товар.
 */
import { getCardPrice } from '@entities/product';
import type { CardPriceStyle } from '@shared/config';

const props = withDefaults(
  defineProps<{
    item: any;
    variant?: CardPriceStyle;
    /** Инвертированный текст — для шаблона с ценой поверх фото. */
    onDark?: boolean;
  }>(),
  { variant: 'plain', onDark: false },
);

const price = computed(() => getCardPrice(props.item));
</script>

<template>
  <span
    class="pcard-price"
    :class="[`pcard-price--${variant}`, { 'pcard-price--on-dark': onDark }]"
  >
    <span v-if="price.from" class="pcard-price__prefix">от</span>
    {{ price.value }} ₽
  </span>
</template>

<style scoped lang="scss">
.pcard-price {
  @apply inline-flex items-baseline gap-1 font-bold tracking-tight whitespace-nowrap;
  @apply text-lg md:text-xl lg:text-2xl;

  &__prefix {
    @apply text-xs md:text-sm font-medium opacity-60;
  }

  &--chip {
    @apply px-2.5 py-1 text-base md:text-lg;
    border-radius: var(--app-radius-control, 9999px);
    background: var(--app-accent, #ef4444);
    color: var(--app-accent-foreground, #fff);

    .pcard-price__prefix {
      @apply opacity-80;
    }
  }

  &--on-dark {
    @apply text-white drop-shadow;
  }
}
</style>
